/* global $:false, swal:false */
;(function () {
  'use strict'

  angular
    .module('pub.shinies', ['pub.shinies.service', 'pub.shinies.odds'])
    .controller('ShiniesCtrl', ShiniesCtrl)

  /** @ngInject */
  function ShiniesCtrl(
    $scope,
    $state,
    $rootScope,
    $stateParams,
    UploadService,
    ShiniesService,
    CollectiblesService,
    ShiniesOddsService,
  ) {
    var vm = this
    vm.model = {}
    vm.collectible = {}
    vm.items = []

    vm.shinyTypes = [
      { id: 0, name: 'Standard' },
      { id: 1, name: 'Bounty' },
      { id: 2, name: 'Redeemable' },
      { id: 3, name: 'Raffle' },
    ]

    vm.renderTypes = [
      { id: 0, t: 'Basic' },
      { id: 1, t: 'White' },
      { id: 2, t: 'Red' },
      { id: 3, t: 'Gold' },
      { id: 4, t: 'Purple' },
      { id: 5, t: 'Metal' },
    ]

    function load() {
      vm.items = []
      CollectiblesService.getId($stateParams.parentId, $stateParams.collectibleId).then(function (result) {
        vm.collectible = result.results
        let item = result.results.shinies
        for (let i = 0; i < item.length; i++) {
          if (item[i]['k-render'] === 0) {
            item[i].typeRender = 'Basic'
          } else if (item[i]['k-render'] === 1) {
            item[i].typeRender = 'Red'
          } else if (item[i]['k-render'] === 2) {
            item[i].typeRender = 'Gold'
          } else if (item[i]['k-render'] === 3) {
            item[i].typeRender = 'Purple'
          }
        }
        vm.items = item
      })
    }

    vm.replicate = function (item) {
      swal(
        {
          title: 'Replicate',
          text: 'You want to replicate this shiny ?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            ShiniesService.replicate(item.id).then(function () {
              swal('Replicated', '', 'success')
              load()
            })
          }
        },
      )
    }

    vm.publish = function (state, item) {
      if (state) {
        ShiniesService.publish(item.id).then(
          function () {
            swal('Published', '', 'success')
            load()
          },
          function (err) {
            var e = err.error.message.split(';')
            var html = ''
            for (var i = 0; i < e.length; i++) {
              if (!e[i]) continue
              html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
            }

            swal({
              title: 'Required',
              text: html,
              html: true,
            })
          },
        )
      } else {
        ShiniesService.unpublish(item.id).then(
          function () {
            swal('Unpublished', '', 'success')
            load()
          },
          function (err) {
            var e = err.error.message.split(';')
            var html = ''
            for (var i = 0; i < e.length; i++) {
              if (!e[i]) continue
              html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
            }
            swal({
              title: 'Required',
              text: html,
              html: true,
            })
          },
        )
      }
    }

    vm.delete = function (id) {
      swal(
        {
          title: 'Delete',
          text: 'You want to delete this shiny ?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            ShiniesOddsService.list(id).then(function (result) {
              if (result.results.length > 0) {
                var promises = []
                for (var i = 0; i < result.results.length; i++) {
                  promises.push(ShiniesOddsService.remove(result.results[i].id))
                }
                Promise.all(promises).then(function () {
                  ShiniesService.remove(id).then(function () {
                    $state.reload()
                  })
                })
              } else {
                ShiniesService.remove(id).then(function () {
                  $state.reload()
                })
              }
            })
          }
        },
      )
    }

    load()

    vm.create = function () {
      vm.model = {}
      $('#myModalShiny').modal('show')
    }

    vm.edit = function (item) {
      vm.model = item
      vm.files = item.qmf
      vm.filesObj = item.obj
      $('#myModalShiny').modal('show')
    }

    vm.pathImgShinyT = ''
    vm.loadShinyT = false
    vm.uploadShinyT = function (item) {
      vm.loadShinyT = true
      UploadService.save('collectibles', vm.pathImgShinyT, 'img-t', item.id).then(function (fileName) {
        vm.loadShinyT = false
        item['img-t'] = fileName
      })
    }

    vm.pathImgShinyL = ''
    vm.loadShinyL = false
    vm.uploadShinyL = function (item) {
      vm.loadShinyL = true
      var id = Math.random().toString(16).slice(2)
      if (item.id) {
        id = item.id
      }
      UploadService.save('collectibles', vm.pathImgShinyL, 'img-l', id).then(function (fileName) {
        vm.loadShinyL = false
        item['img-l'] = fileName
      })
    }

    vm.pathImgShinyBL = ''
    vm.loadShinyBL = false
    vm.uploadShinyBL = function (item) {
      vm.loadShinyBL = true
      var id = Math.random().toString(16).slice(2)
      if (item.id) {
        id = item.id
      }
      UploadService.save('collectibles', vm.pathImgShinyBL, 'img-b-l', id).then(function (fileName) {
        vm.loadShinyBL = false
        item['img-b-l'] = fileName
      })
    }

    vm.pathImgShinyQMF = ''
    vm.loadShinyQMF = false
    vm.uploadShinyQMF = function (item) {
      vm.loadShinyQMF = true
      var id = Math.random().toString(16).slice(2)
      if (item.id) {
        id = item.id
      }
      UploadService.save('collectibles', vm.pathImgShinyQMF, 'qmf', id).then(function (fileName) {
        vm.loadShinyQMF = false
        item['qmf'] = fileName
      })
    }

    vm.classDisabledShiny = function () {
      if (!vm.model.t) {
        return 'is-disabled'
      } else {
        return
      }
    }

    vm.saveShiny = function () {
      vm.model['id-q'] = vm.collectible.id
      delete vm.model.qmf
      if (vm.model.id && vm.model.id !== 0) {
        CollectiblesService.updateShiny(vm.model.id, vm.model).then(
          function () {
            $('#myModalShiny').modal('hide')
            vm.model = {}
            swal('Saved!', '', 'success')
            $state.reload()
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      } else {
        CollectiblesService.saveShiny(vm.collectible.id, vm.model).then(
          function () {
            $('#myModalShiny').modal('hide')
            vm.model = {}
            swal('Saved!', '', 'success')
            $state.reload()
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      }
    }

    vm.deleteImage = function (item) {
      vm.model[item] = ''
    }

    vm.odds = function (item) {
      $state.go('pub.collectibles.shinies.odds', { shinyId: item.id })
    }

    vm.loading = false
    var watch = $scope.$watch('vm.qmfFile', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }

      vm.model.id = parseInt(vm.model.id)

      var nameFile = newVal.name.split('.')[0]
      var fileNameZip = nameFile + '-' + vm.model.id + '-' + new Date().getTime() + '.' + 'zip'
      vm.model.qmf = fileNameZip
      vm.model['id-q'] = vm.collectible.id
      CollectiblesService.updateShiny(vm.model.id, vm.model).then(function () {})

      vm.loading = true
      UploadService.saveQmf('collectibles', newVal, '', vm.model.id).then(function (file) {
        vm.files = file
        toastr.success('Process complete!')
        vm.loading = false
      })
    })

    vm.loadingObj = false
    vm.newUploadObj = false
    var watch2 = $scope.$watch('vm.objFile', function (newVal, oldVal) {
      if (!newVal) {
        vm.loadingObj = false
        return
      }
      if (newVal === oldVal) {
        vm.loadingObj = false
        return
      }

      var id = Math.random().toString(16).slice(2)
      if (vm.model.id) {
        id = vm.model.id
        vm.model.id = parseInt(vm.model.id)
      }

      vm.loadingObj = true
      UploadService.save('collectibles', newVal, 'obj-data', id).then(function (fileName) {
        vm.filesObj = fileName
        vm.model.obj = fileName
        vm.loadingObj = false
        vm.newUploadObj = true
        vm.glbProgress = 0
        toastr.success('Upload complete!')
      })
    })

    vm.glbProgress = 0
    $rootScope.$on('uploadProgress', function (event, data) {
      vm.glbProgress = data
      $scope.$apply()
    })

    $scope.$on('$destroy', function () {
      watch()
      watch2()
    })
  }
})()
